import DetectRTC from "detectrtc";
import { detect } from "detect-browser";

export const isMobileBrowser = DetectRTC.isMobileDevice;

const userAgent = window.navigator.userAgent.toLowerCase();
const isSafari = /safari/.test(userAgent);
const isIos = /iphone|ipod|ipad/.test(userAgent);

export const isIosBrowser = isIos && isSafari;
export const isIosWebview = isIos && !isSafari;

export const isAudioCallSupported =
  DetectRTC.isWebRTCSupported && DetectRTC.isGetUserMediaSupported;

export const isVideoCallSupported = isBrowserMeetsVersionRequirements({
  desktop: { chrome: 64, firefox: 58 },
  mobile: { chrome: 70, safari: 11 }
});

export const isFullscreenSupported = isBrowserMeetsVersionRequirements({
  desktop: { chrome: 64, firefox: 58 },
  mobile: { chrome: 70 }
});

export const isScreenSharingSupported = isBrowserMeetsVersionRequirements({
  desktop: { chrome: 72, firefox: 67 }
});

type BrowserConstraints = {
  Chrome?: number;
  Firefox?: number;
  Safari?: number;
  [key: string]: number | undefined;
};

function isBrowserMeetsVersionRequirements(req: {
  desktop?: BrowserConstraints;
  mobile?: BrowserConstraints;
}): boolean {
  const browser = detect();
  if (!browser) {
    return false;
  }
  const browserName = browser.name.toLowerCase();
  const browserVersion = parseInt(browser.version?.split(".")[0] || "");

  const constraints = DetectRTC.isMobileDevice ? req.mobile : req.desktop;
  const minimalVersion = constraints && constraints[browserName];
  return minimalVersion !== undefined && browserVersion >= minimalVersion;
}
